const WEBKIT_MESSAGE_HANDLERS = /window\.webkit\.messageHandlers/;

type ExceptionListItem = {
  value?: unknown;
};

/**
 * Capture shape accepted by posthog-js `before_send`. Kept structural so widget
 * bundles do not import PostHog types.
 */
export type ExceptionCapture = {
  event?: string;
  properties?: {
    $exception_list?: unknown;
    $exception_message?: unknown;
  };
} | null;

const messageMatches = (value: unknown): value is string =>
  typeof value === "string" && WEBKIT_MESSAGE_HANDLERS.test(value);

/**
 * True for the Safari TypeError thrown when an injected script (Chrome or
 * Firefox for iOS, Facebook, Instagram) reads `window.webkit.messageHandlers`
 * outside a WKWebView that registered a handler. Application code never
 * touches that bridge, so the exception is host-page noise.
 */
export const isInjectedWebKitBridgeException = (
  event: ExceptionCapture,
): boolean => {
  if (!event || event.event !== "$exception") return false;

  const properties = event.properties;
  if (!properties) return false;

  if (messageMatches(properties.$exception_message)) return true;

  const list = properties.$exception_list;
  if (!Array.isArray(list)) return false;

  return list.some(
    item =>
      !!item &&
      typeof item === "object" &&
      messageMatches((item as ExceptionListItem).value),
  );
};
